<h2 mat-dialog-title>
  {{ 'INTEGRATIONS.IDENTITY_PROVIDER.DELETE_DIALOG.DELETE_INTEGRATION' | translate }}
</h2>
<mat-dialog-content>
  <p>
    {{ 'INTEGRATIONS.IDENTITY_PROVIDER.DELETE_DIALOG.ONCE_DELETED' | translate }}
  </p>
  <p>
    {{ 'INTEGRATIONS.IDENTITY_PROVIDER.DELETE_DIALOG.NEW_USERS' | translate }}
  </p>
  <p>
    {{ 'INTEGRATIONS.IDENTITY_PROVIDER.DELETE_DIALOG.EXISTING_USERS' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose [disabled]="deleting$$ | async">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-raised-button color="warn" [disabled]="deleting$$ | async" (click)="delete()">
    {{ 'COMMON.ACTION_LABELS.DELETE' | translate }}
  </button>
</mat-dialog-actions>
